import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { HealthHeroBGC } from "../../constant";

export default function HealthAndPharmaLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "80vh" },
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh", // Use dvh for mobile browsers
          minHeight: "-webkit-fill-available", // Better mobile support
          zIndex: -1,
          overflow: "hidden",
          pointerEvents: "none",
          background: "black",
          "::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            //transform: "scaleX(-1)",
            filter: "brightness(0.8)",
            minHeight: "-webkit-fill-available",
          }}
        >
          <source src={HealthHeroBGC} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          margin: "0 auto",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: isMobile ? "100%" : "50%",
            maxWidth: "1200px",
            textAlign: "left",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={12} lg={12}>
              <Typography
                variant="h2"
                sx={{
                  background:
                    "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "center",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {`Building the Future of Healthcare & Pharmaceuticals`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12}>
              <Typography
                sx={{
                  color: "white",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.8,
                  textAlign: "center",
                  marginTop: 5,
                }}
              >
                {`Healthcare and pharmaceutical enterprises face increasing demands around patient safety, product quality, regulatory oversight, workforce effectiveness, and environmental responsibility. IENERGY enables organizations to modernize critical processes through integrated solutions that improve accountability, strengthen governance, and support informed decision-making. 

By connecting quality, compliance, operations, workforce, assets, and sustainability initiatives, organizations gain the visibility and control needed to achieve higher standards of performance while maintaining trust, safety, and regulatory excellence.`}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        
        {/* Bottom aligned text */}
        <Box sx={{ mt: "auto", mb: 4, width: "100%", textAlign: "center" }}>
          <Typography
            sx={{
              color: "white",
              fontSize: { xs: "14px", md: "16px" },
              lineHeight: 1.8,
              textAlign: "center",
            }}
          >
            {`Enabling safer care, stronger compliance, and sustainable growth across the healthcare and pharmaceutical value chain.`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}